export default __webpack_public_path__ + "static/media/glimpse.b6f31993.png";